import React from 'react'

import PopupMenuButton from "../../popover-menu/popup-menu-button/popup-menu-button"
import PopoverMenuAddAttachment from "./popover-menu"

type Props = {
    className?  :   string
    disabled?   :   boolean
    onSelect    :   {(value:'google-drive' | 'local'):void}
}

const ButtonAddAttachmentLink = (props: Props) => {

    const btnComponent = () => (
        <React.Fragment>
            <div className="ui5-link-add-item">
                <div className="icon i5-plus"/>
                Attach file
            </div>
        </React.Fragment>
    )

    return <PopupMenuButton className           =   {Classes("add-attachment", props.className)}
                            btnComponent        =   {btnComponent}
                            disabled            =   {props.disabled}
                            attachment          =   "top center"
                            targetAttachment    =   "bottom center"
                            offset              =   "0 0"
                            menuComponent       =   {PopoverMenuAddAttachment}
                            menuParams          =   {{
                                onFromComputer      : ()=>{props.onSelect('local')},
                                onFromGoogleDrive   : ()=>{props.onSelect('google-drive')},
                            }}/>
}

export default ButtonAddAttachmentLink
